// import { all, put, takeEvery, call } from 'redux-saga/effects'

export default function* rootSaga(): Generator {
  // yield all([
  // ])
}
